import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderComponent } from './common/components/header/header.component';
import { FooterComponent } from './common/components/footer/footer.component';
import { NavigationComponent } from './common/components/navigation/navigation.component';

import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ContentLayoutComponent } from './common/components/layout/content-layout/content-layout.component';
import { FullLayoutComponent } from './common/components/layout/full-layout/full-layout.component';
import { CustomizerComponent } from './common/components/customizer/customizer.component';

import { RightSidebarComponent } from './common/components/right-sidebar/right-sidebar.component';
import { SidebarComponent } from './common/components/sidebar/sidebar.component';
import { SharedModule } from './common/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';

import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFormatter } from './common/formatter/date.formatter';
import { AppSettingsService } from "./common/appsettings.service";
import { Observable } from 'rxjs';
import { PortalModule } from './portal/portal.module';
import { JwtInterceptor } from './auth/jwt.interceptor';
import { ErrorInterceptor } from './auth/error.interceptor';
import { PortalCommonModule } from './portal/portal-common.module';
import { LoginComponent } from './auth/login.component';

export class CustomLoader implements TranslateLoader {

    constructor(private http: HttpClient) {

    }
    getTranslation(language: string): Observable<any> {
        // Condition satisfies upon page load. com.json is loaded.
        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};

        if (!language && browserWindowEnv.hasOwnProperty('defaultSystemLangId') ) {
            var languageID = window['__env']['defaultSystemLangId'];
            if (languageID == "1")
                language = "en";
            else if (languageID == "2")
                language = "ar";
            else if (languageID == "3")
                language = "fr";
        }

        if (browserWindowEnv.hasOwnProperty('takaful') && window['__env']['takaful'] == "true") {
            return this.http.get('scripts/libs/assets/i18n/ta' + language + '.json');
        }
        else {
            return this.http.get('scripts/libs/assets/i18n/' + language + '.json');
        }
    }
}

@NgModule({
    declarations: [
        FullLayoutComponent,
        ContentLayoutComponent,
        CustomizerComponent,
        RightSidebarComponent,
        SidebarComponent,
        AppComponent,
        HeaderComponent,
        FooterComponent,
        NavigationComponent,
        LoginComponent
    ],
    imports: [
        ReactiveFormsModule,
        PortalCommonModule,
        NgbModule,
        NgxPaginationModule,
        NgxSpinnerModule,
        NgProgressModule,
        NgProgressHttpModule,
        ChartsModule,
        FormsModule,
        SharedModule,
        BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        PortalModule,
        TranslateModule.forRoot({
            loader: { provide: TranslateLoader, useClass: CustomLoader, deps: [HttpClient] },
            //missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
            isolate: false
        }),
        ToastrModule.forRoot({
            "timeOut": 5000,
            "closeButton": true,
            "progressBar": true,
            "positionClass": "toast-top-right",
            "extendedTimeOut": 1000,
            "preventDuplicates": true
        })
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: NgbDateParserFormatter, useClass: NgbDateFormatter },
        AppSettingsService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    const browserWindow = window || {};
    const browserWindowEnv = browserWindow['__env'] || {};
    if (browserWindowEnv.hasOwnProperty('takaful') && window['__env']['takaful'] == "true")
        return new TranslateHttpLoader(http, "scripts/libs/assets/i18n/ta");
    else
        return new TranslateHttpLoader(http, "scripts/libs/assets/i18n/");
}
